import React, { useState } from 'react';
import TableActions from './TableActions';
import { formatCellValue } from '../../Utils/formatters';
import { TEMPLATE_COLUMNS } from '../../Utils/constants';

/**
 * Table Row Component
 * Renders a single template table row with actions
 * Note: Custom tables now use TableBuilder which has its own row rendering
 */
const TableRow = ({ 
  row, 
  rowIndex, 
  table, 
  onEdit, 
  onDelete, 
  permissions = {}
}) => {
  const [expandedCells, setExpandedCells] = useState(new Set());

  const toggleCellExpansion = (cellKey) => {
    const newExpanded = new Set(expandedCells);
    if (newExpanded.has(cellKey)) {
      newExpanded.delete(cellKey);
    } else {
      newExpanded.add(cellKey);
    }
    setExpandedCells(newExpanded);
  };

  const renderCellContent = (value, columnKey) => {
    const isExpanded = expandedCells.has(`${rowIndex}-${columnKey}`);
    const cellId = `${rowIndex}-${columnKey}`;
    
    if (!value && value !== 0 && value !== false) return '';
    
    const formattedValue = formatCellValue(value, 'text');
    const needsExpansion = typeof value === 'string' && value.length > 50;
    
    return (
      <div 
        className={`cell-content ${isExpanded ? 'expanded' : ''} ${needsExpansion ? 'cell-expandable' : ''}`}
        onClick={needsExpansion ? () => toggleCellExpansion(cellId) : undefined}
        title={needsExpansion ? 'Click to expand/collapse' : value}
        style={{ cursor: needsExpansion ? 'pointer' : 'default' }}
      >
        {isExpanded ? value : formattedValue}
      </div>
    );
  };

  return (
    <tr key={row.id || rowIndex}>
      {TEMPLATE_COLUMNS.map((column) => (
        <td key={column.key}>
          {renderCellContent(row[column.key], column.key)}
        </td>
      ))}
      <td className="table-actions-column">
        <TableActions
          onEdit={() => onEdit(rowIndex)}
          onDelete={(event) => {
            event?.stopPropagation?.();
            onDelete(row);
          }}
          canEdit={permissions.canEdit}
          canDelete={permissions.canDelete}
          disabled={permissions.isRestricted}
        />
      </td>
    </tr>
  );
};

export default TableRow;
